// <s-finder-nudge> shows one small "Find your match" pill after real browsing:
// half the page scrolled or 40 seconds on the page, whichever comes first.
// Never more than once per visit, hidden for 30 days once dismissed, never again once
// the finder has been used, and it fades away on its own after 15 seconds.
const DISMISS_KEY = 'rnu-nudge-dismissed';
const USED_KEY = 'rnu-finder-used';
const SESSION_KEY = 'rnu-nudge-seen';
const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;

class SFinderNudge extends HTMLElement {
  #ac = null;
  #timers = [];

  connectedCallback() {
    if (!this.#allowed()) return;
    this.#ac = new AbortController();
    const { signal } = this.#ac;

    window.addEventListener('scroll', this.#onScroll, { passive: true, signal });
    this.#timers.push(setTimeout(() => this.#reveal(), 40000));
    this.querySelector('[data-nudge-dismiss]')?.addEventListener('click', this.#dismiss, { signal });
    this.querySelector('[data-nudge-open]')?.addEventListener('click', () => this.#hide(), { signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#timers.forEach(clearTimeout);
  }

  #allowed() {
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return false;
      if (localStorage.getItem(USED_KEY)) return false;
      const dismissed = Number(localStorage.getItem(DISMISS_KEY) || 0);
      if (dismissed && Date.now() - dismissed < THIRTY_DAYS) return false;
    } catch (error) {
      return false;
    }
    return true;
  }

  #onScroll = () => {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= 0.5) this.#reveal();
  };

  #reveal() {
    if (!this.hidden || !this.#allowed()) return;
    if (document.querySelector('dialog[open]')) return;
    this.hidden = false;
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (error) { /* storage blocked */ }
    window.removeEventListener('scroll', this.#onScroll);
    this.#timers.push(setTimeout(() => this.#hide(), 15000));
  }

  #hide() {
    this.hidden = true;
    this.#ac?.abort();
  }

  #dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (error) { /* storage blocked */ }
    this.#hide();
  };
}

if (!customElements.get('s-finder-nudge')) customElements.define('s-finder-nudge', SFinderNudge);
